<div class="info-banner" [ngClass]="type">
  @if (type === 'warning') {
    <svg id="warning-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3358_190054)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 0H0V14H14V0ZM7.74994 3H6.24994L6.49994 8.5H7.49994L7.74994 3ZM7.74994 9.5H6.24994V11H7.74994V9.5Z"
          fill="#FF551E"
        />
      </g>
      <defs>
        <clipPath id="clip0_3358_190054">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  } @else {
    <svg id="error-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3358_190054)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 15L8 1L0 15H16ZM8.75 5.5H7.25L7.5 11H8.5L8.75 5.5ZM8.75 12H7.25V13.5H8.75V12Z"
          fill="#BE3533"
        />
      </g>
      <defs>
        <clipPath id="clip0_3358_190054">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  }
  <div class="banner-content">
    <ng-content></ng-content>
  </div>
</div>
